import React from "react";
import { Box, Container, Typography, Alert, Stack, Divider, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLegalDocs, LEGAL_DRAFT } from "./legalContent";

// Універсальна сторінка юридичного документа (terms/privacy/cookies/dpa).
// Рендерить документ мовою інтерфейсу; юридично основна — польська версія
// (про це сказано в самих документах).
export default function LegalPage({ doc }) {
  const { t, i18n } = useTranslation();
  const docs = getLegalDocs(i18n.language);
  const d = docs[doc];
  if (!d) return null;
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={800} sx={{ mb: 0.5 }}>{d.title}</Typography>
      <Typography variant="caption" color="text.secondary">
        {t('legal.updatedAt', { date: d.updated })}
      </Typography>

      {LEGAL_DRAFT && (
        <Alert severity="info" sx={{ my: 2 }}>{t('legal.entityPendingNote')}</Alert>
      )}

      <Stack spacing={2.5} sx={{ mt: 2 }}>
        {d.sections.map((s, i) => (
          <Box key={i}>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>{s.h}</Typography>
            {s.body.map((p, j) => (
              <Typography key={j} sx={{ color: "text.secondary", mb: 1 }}>{p}</Typography>
            ))}
          </Box>
        ))}
      </Stack>

      <Divider sx={{ my: 3 }} />
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <MuiLink component={Link} to="/terms" variant="caption" underline="hover">{docs.terms.title}</MuiLink>
        <MuiLink component={Link} to="/privacy" variant="caption" underline="hover">{docs.privacy.title}</MuiLink>
        <MuiLink component={Link} to="/cookies" variant="caption" underline="hover">{docs.cookies.title}</MuiLink>
        <MuiLink component={Link} to="/dpa" variant="caption" underline="hover">{docs.dpa.title}</MuiLink>
        <MuiLink component={Link} to="/refund" variant="caption" underline="hover">{docs.refund.title}</MuiLink>
      </Stack>
    </Container>
  );
}
